export var DECIMAL = "decimal";
export var CURRENCY = "currency";
export var ACCOUNTING = "accounting";
export var PERCENT = "percent";
export var SCIENTIFIC = "scientific";

export var CURRENCY_PLACEHOLDER = "$";
export var PERCENT_PLACEHOLDER = "%";
export var NUMBER_PLACEHOLDER = "n";

export var LIST_SEPARATOR = ";";
export var GROUP_SEPARATOR = ",";

export var POINT = ".";
export var EMPTY = "";

export var DEFAULT_LOCALE = "en";




//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@telerik/kendo-intl/dist/es/common/constants.js
// module id = ../../../../@telerik/kendo-intl/dist/es/common/constants.js
// module chunks = vendor